function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/react-datepicker/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 1015
// module chunks = 39